import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Flex, Box } from 'reflexbox';
import {
  Toolbar,
  NavItem,
  Dropdown,
  DropdownMenu,
  Arrow,
} from 'rebass';
import { withRouter, routerShape } from 'react-router';
import UpdateAwareLink from 'frontend/components/UpdateAwareLink';
import SvgIcons from 'frontend/SvgIcons';

import Responsive from 'frontend/components/Responsive';
import {
  If,
} from 'frontend/components';

import config from 'frontend/config';

const TabBar = ({ children }) => (
  <Toolbar
    p={0}
    backgroundColor="inherit"
    style={{ minHeight: '32px', borderBottom: `solid 1px ${config.colors.orange}` }}
  >
    {children}
  </Toolbar>
);
TabBar.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
  ]).isRequired,
};

const TabItem = withRouter(({ item, to, router, children }) => {
  const height = 24;
  const slug = _.camelCase(item.shortName);
  const selected = (to === router.location.pathname);
  return (
    <NavItem
      id={`tab-link-${slug}`}
      p={1}
      pl={2}
      pr={2}
      backgroundColor={selected ? config.colors.orange : undefined}
      color={selected ? config.colors.black : undefined}
      is={UpdateAwareLink}
      to={to}
    >
      <Flex align="center" style={{ height }}>
        <Box m={0} p={0} style={{ height }}>
          <item.icon
            style={{
              width: 24,
              height,
              marginRight: 8,
              fill: selected ? config.colors.black : config.colors.orange,
            }}
          />
        </Box>
        <Box m={0} p={0}>
          {children}
        </Box>
      </Flex>
    </NavItem>
  );
});

TabItem.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
};

class Tabs extends React.Component {
  static propTypes = {
    router: routerShape.isRequired,
  };

  state = {
    dropdownOpen: false,
  };

  toggleMenu = () => this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }));

  render() {
    const { router } = this.props;
    const items = [{
      to: '/simbot/topgear',
      longName: 'Top Gear',
      shortName: 'Top Gear',
      main: true,
      icon: SvgIcons.optimize.small,
    }, {
      to: '/simbot/droptimizer',
      longName: 'Droptimizer',
      shortName: 'Droptimizer',
      main: true,
      icon: SvgIcons.die.small,
    }, {
      to: '/simbot/quick',
      longName: 'Quick Sim',
      shortName: 'Quick',
      main: true,
      icon: SvgIcons.quick.small,
    }, {
      to: '/simbot/gear',
      longName: 'Gear Compare',
      shortName: 'Gear',
      main: false,
      icon: SvgIcons.gear.small,
    }, {
      to: '/simbot/advanced',
      longName: 'Advanced',
      shortName: 'Advanced',
      main: true,
      icon: SvgIcons.advanced.small,
    }, {
      to: '/simbot/stats',
      longName: 'Stat Weights',
      shortName: 'Stats',
      main: false,
      icon: SvgIcons.stats.small,
    }];
    const selected = _.find(items, { to: router.location.pathname });
    const mainItems = _.filter(items, { main: true });
    const otherItems = _.filter(items, { main: false });
    return (
      <Box id="header-tabs">
        <Responsive size="large">
          <TabBar>
            {mainItems.map(item => (
              <TabItem to={item.to} key={item.to} item={item}>
                {item.longName}
              </TabItem>
            ))}
            <Dropdown>
              <NavItem onClick={this.toggleMenu}>
                More <Arrow />
              </NavItem>
              <DropdownMenu
                onDismiss={this.toggleMenu}
                open={this.state.dropdownOpen}
              >
                {otherItems.map(item => (
                  <TabItem to={item.to} key={item.to} item={item}>
                    {item.shortName}
                  </TabItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </TabBar>
        </Responsive>
        <Responsive size="small" component="span">
          <TabBar>
            <If
              condition={selected}
              then={() => (
                <TabItem to={selected.to} item={selected}>
                  {selected.longName}
                </TabItem>
              )}
            />
            <Dropdown>
              <NavItem onClick={this.toggleMenu}>
                More <Arrow />
              </NavItem>
              <DropdownMenu
                onDismiss={this.toggleMenu}
                open={this.state.dropdownOpen}
              >
                {items.map(item => (
                  <TabItem to={item.to} key={item.to} item={item}>
                    {item.shortName}
                  </TabItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </TabBar>
        </Responsive>
      </Box>
    );
  }
}

export default withRouter(Tabs);
